import { render, staticRenderFns } from "./commonFields.vue?vue&type=template&id=b880a17c"
import script from "./commonFields.vue?vue&type=script&lang=js"
export * from "./commonFields.vue?vue&type=script&lang=js"
import style0 from "./commonFields.vue?vue&type=style&index=0&id=b880a17c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports